<template>
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.75 3C7.7165 3 8.5 3.7835 8.5 4.75V11.75C8.5 12.7165 7.7165 13.5 6.75 13.5H1.75C0.783502 13.5 0 12.7165 0 11.75V4.75C0 3.7835 0.783502 3 1.75 3H6.75ZM1.75 4.5C1.61193 4.5 1.5 4.61193 1.5 4.75V11.75C1.5 11.8881 1.61193 12 1.75 12H6.75C6.88807 12 7 11.8881 7 11.75V4.75C7 4.61193 6.88807 4.5 6.75 4.5H1.75Z"
      fill="#868D9C"
    />
    <path
      d="M6.75 0C9.37335 0 11.5 2.12665 11.5 4.75V10.75C11.5 11.1642 11.1642 11.5 10.75 11.5C10.3358 11.5 10 11.1642 10 10.75V4.75C10 2.95507 8.54493 1.5 6.75 1.5H2.75C2.33579 1.5 2 1.16421 2 0.75C2 0.335786 2.33579 0 2.75 0H6.75Z"
      fill="#868D9C"
    />
  </svg>
</template>
